import { FunctionComponent } from "react";
import { Pencil } from "react-huge-icons/outline";
import { Link } from "react-router-dom";
import MeasurementInput from "../../../components/MeasurementInput";
import { BMI, Fat, HeartRate, Height, Weight } from "../../../assets/svg-icons";
import { useTranslation } from "react-i18next";
import { Measurement } from "src/graphql";
import calculateBMI from "src/utils/calculate-bmi";

interface MeasurementsArticleProps {
    measurement?: Partial<Measurement>
}

const MeasurementsArticle: FunctionComponent<MeasurementsArticleProps> = ({ measurement }) => {

    const { t } = useTranslation();

    return (<article>
        <h1 className='purple'>{t("measurements")}</h1>
        <nav>
            <Link to='/my-profile#measurement'>
                <div className=' bg-light rounded-full p-1 hover:bg-dark/20'>
                    <Pencil className='h-5 w-5 text-dark' />
                </div>
            </Link>
        </nav>

        {measurement?.__typename ?
            <div className='flex flex-row'>
                <div className='flex flex-wrap gap-2 items-center'>

                    <div className='min-w-[120px]'>
                        <MeasurementInput readOnly inputProps={{ value: measurement.weight || "" }} unit='kg' color='orange' label={t("weight")} icon={() => <img alt='weight' className='w-6 md:w-7' src={Weight} />} />
                    </div>
                    <div className='min-w-[120px]'>
                        <MeasurementInput readOnly inputProps={{ value: measurement.height || "" }} unit='cm' color='purple' label={t("height")} icon={() => <img alt='Height' className='w-6 md:w-7' src={Height} />} />
                    </div>
                    <div className='min-w-[120px]'>
                        <MeasurementInput readOnly inputProps={{ value: measurement.heart_rate || "" }} unit='BPM' color='red' label={t("heart_rate")} icon={() => <img alt='HeartRate' className='w-6 md:w-7' src={HeartRate} />} />
                    </div>
                    {/* <div className='min-w-[120px]'>
                        <MeasurementInput readOnly inputProps={{ value: calculateBMI(measurement.height) || "" }} unit='' color='blue' label='BMI' icon={() => <img alt='BMI' className='w-6 md:w-7' src={BMI} />} />
                    </div> */}
                    <div className='min-w-[120px]'>
                        <MeasurementInput readOnly inputProps={{ value: measurement.fat || "" }} unit='%' color='cyan' label={t("fat")} icon={() => <img alt='Fat' className='w-6 md:w-7' src={Fat} />} />
                    </div>

                </div>
            </div>
            :
            <div>
                {t("You have not created any measurement yet.")} <Link className="text-blue" to='/my-profile#measurement'>
                    {t("click_here")}
                </Link> {t("to create a new measurement.")}
            </div>
        }
    </article>);
}

export default MeasurementsArticle;